<div class="px-8">
  <p-card class="m-2">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
      <div class="flex justify-between items-center border-b pb-4">
        <h2 class="text-xl font-bold text-gray-800">
          {{ isEditMode ? 'Editar Funcionário' : 'Novo Funcionário' }}
        </h2>
      </div>

      <p-tabView styleClass="mb-4">
        <!-- Tab Dados pessoais -->
        <p-tabPanel header="Dados pessoais">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
            <div class="md:col-span-2">
              <label class="block mb-1 text-sm font-medium text-gray-700">Nome completo *</label>
              <input
                pInputText
                type="text"
                formControlName="fullName"
                class="w-full"
                [ngClass]="{
                  'ng-invalid ng-dirty':
                    form.get('fullName')?.invalid && form.get('fullName')?.touched
                }"
              />
              <small
                class="text-red-500"
                *ngIf="form.get('fullName')?.invalid && form.get('fullName')?.touched"
              >
                Nome é obrigatório
              </small>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Apelido</label>
              <input pInputText type="text" formControlName="nickName" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">CPF</label>
              <input pInputText type="text" formControlName="cpf" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">RG</label>
              <input pInputText type="text" formControlName="rg" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Status</label>
              <p-dropdown
                [options]="[
                  { label: 'Ativo', value: true },
                  { label: 'Inativo', value: false }
                ]"
                formControlName="active"
                placeholder="Selecione o status"
                class="w-full"
              ></p-dropdown>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Dia de pagamento</label>
              <p-inputNumber formControlName="paymentDay" [min]="1" [max]="31" class="w-full" placeholder="Ex: 5"></p-inputNumber>
            </div>
          </div>
        </p-tabPanel>

        <!-- Tab Endereço -->
        <p-tabPanel header="Endereço">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">CEP</label>
              <input pInputText type="text" formControlName="cep" class="w-full" />
            </div>
            <div class="md:col-span-2">
              <label class="block mb-1 text-sm font-medium text-gray-700">Logradouro</label>
              <input pInputText type="text" formControlName="address" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Número</label>
              <input pInputText type="text" formControlName="addressNumber" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Complemento</label>
              <input pInputText type="text" formControlName="addressComplement" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Bairro</label>
              <input pInputText type="text" formControlName="district" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Estado</label>
              <input pInputText type="text" formControlName="state" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Cidade</label>
              <input pInputText type="text" formControlName="city" class="w-full" />
            </div>
          </div>
        </p-tabPanel>

        <!-- Tab Contato -->
        <p-tabPanel header="Contato">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Telefone</label>
              <input pInputText type="text" formControlName="phone" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Celular</label>
              <input pInputText type="text" formControlName="cellPhone" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">WhatsApp</label>
              <input pInputText type="text" formControlName="whatsApp" class="w-full" />
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">E-mail</label>
              <input pInputText type="email" formControlName="email" class="w-full" />
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>

      <div class="pt-4 border-t text-right">
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-secondary mr-2"
          (click)="goBack()"
        ></button>
        <button
          pButton
          type="submit"
          label="Salvar"
          icon="pi pi-save"
          class="p-button-primary"
        ></button>
      </div>
    </form>
  </p-card>
</div>
